module.exports = __webpack_public_path__ + "static/media/tulleord-norming-tutorial-1.b5278863.mp3";